import { motion } from "framer-motion";
import { Award, DollarSign, Clock } from "lucide-react";
const pillars = [{
  icon: Award,
  title: "Prestigio",
  subtitle: "Elevación de Valor",
  description: "Blindamos la reputación y elevamos la percepción de valor para que tu empresa ocupe el lugar de reconocimiento que le pertenece.",
  points: ["Posicionamiento", "Percepción", "Proyección", "Prestigio"]
}, {
  icon: DollarSign,
  title: "Dinero",
  subtitle: "Escalabilidad",
  description: "Los números marcan la jugada. Trazamos la hoja de ruta para una expansión sólida que proyecte crecimiento en el mercado.",
  points: ["Modelo de Valor", "Ventas", "Diversificación", "Rentabilidad"]
}, {
  icon: Clock,
  title: "Tiempo",
  subtitle: "Ingeniería de Procesos",
  description: "Valoramos el tiempo como tu activo más escaso. Diseñamos la arquitectura de sistemas que optimicen tu operatividad.",
  points: ["Sistematización", "Optimización", "Planificación", "Calendarización"]
}];
const Solution = () => {
  return <section className="py-24 md:py-32 relative overflow-hidden bg-foreground text-background" id="solucion">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-900 to-black" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-3xl" />
      
      <div className="container px-4 relative z-10">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto mb-20">
          <span className="text-sm font-semibold tracking-widest uppercase mb-4 block text-gold-light">
            Marcas Valiosas, Negocios Visionarios
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Arquitectura de{" "}
            <span className="text-gradient-gold">Reputación©</span>
          </h2>
          <p className="text-lg text-neutral-400 max-w-3xl mx-auto">
            Diseñamos el ecosistema estratégico que permite a empresas consolidadas evolucionar hacia Marcas referentes.
          </p>
        </motion.div>

        {/* Pillars grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group">
              <div className="bg-neutral-900/50 backdrop-blur-sm rounded-2xl p-8 h-full border border-neutral-800 hover:border-primary/50 transition-all duration-500 hover:shadow-lg hover:shadow-primary/10">
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <pillar.icon className="w-8 h-8 text-primary-foreground" />
                </div>

                {/* Title & Subtitle */}
                <h3 className="font-display text-2xl font-bold text-white mb-1">
                  {pillar.title}
                </h3>
                <p className="font-medium mb-4 text-gold-light">
                  {pillar.subtitle}
                </p>

                {/* Description */}
                <p className="text-neutral-400 text-sm leading-relaxed mb-6">
                  {pillar.description}
                </p>

                {/* Points */}
                <ul className="space-y-2">
                  {pillar.points.map(point => <li key={point} className="flex items-center gap-2 text-sm text-neutral-300">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                      {point}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export default Solution;